import React from 'react';
import { Autocomplete, TextField, Box } from '@mui/material';

export default function AutoSearchDropdown({
  id,
  name,
  placeholder,
  disabled = false,
  options = [],
  value,
  onChange,
  sx = {},
  getOptionLabel = (option) => option.label || '',
}) {
  return (
    <Box sx={{ minWidth: 120 }}>
      <Autocomplete
        id={id}
        options={options}
        getOptionLabel={getOptionLabel}
        value={value || null}
        onChange={(event, newValue) => {
          onChange({
            target: {
              name: name,
              value: newValue ? newValue.value : '', // assuming option is { label, value }
            },
          });
        }}
        isOptionEqualToValue={(option, val) => option.value === val}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            size="small"
            disabled={disabled}
            sx={{
                '& .MuiOutlinedInput-root': {
                  height: '50px',
                  borderRadius: '10px',
                  backgroundColor: '#ffffff'
                },
                '& .MuiAutocomplete-inputRoot': {
                  padding: '0 14px'
                },
                '& .MuiInputBase-input': {
                  padding: '10px 0'
                }
              }}
          />
        )}
        disabled={disabled}
        sx={{ width: '100%', ...sx }}
      />
    </Box>
  );
}
